/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { NgModule } from '@angular/core';
import { FeatureReportDisplayComponent } from './reportDisplay/feature-report-display.component';
import { UiModule } from '../../core/ui/ui.module';
import { ReportControlsComponent } from './interface/reportControls/report-controls.component';
import { UploadDialogComponent } from './interface/reportControls/upload/upload-dialog.component';
import { UploadComponent } from './interface/reportControls/upload/upload.component';
import { MediaUploadComponent } from './interface/reportControls/upload/media-upload.component';
import { ReportComponent } from './report.component';
import { DataFormDialogComponent } from './dataForm/data-form-dialog.component';
import { ReportVideoDialogComponent } from './reportDisplay/report-video-dialog.component';
import { ReportTabsComponent } from './interface/reportTabs/report-tabs.component';
import { ReportSelectorComponent } from './interface/reportSelector/report-selector.component';
import { FeatureReportComponent } from './reportTypes/featureReport/feature-report.component';
import { DataReportComponent } from './reportTypes/dataReport/data-report.component';
import { RouterModule } from '@angular/router';
import { DataReportDisplayComponent } from './reportDisplay/data-report-display.component';
import { LineIsolationModule } from '../../components/isolation/line-isolation.module';
import { GsptModule } from '../../components/gspt/gspt.module';
import { DataPrintModule } from '../../components/dataPrint/data-print.module';
import { ReportPrintComponent } from './interface/reportControls/print/report-print.component';
import { MomentModule } from 'ngx-moment';
import { ZoomButtonModule } from '../../core/ui/zoomButton/zoom-button.module';
import { SharedModule } from '../shared/shared.module';
import { ReportContentModule } from './reportContent/report-content.module';
import { ReportDisplayBaseComponent } from './reportDisplay/report-display-base.component';
import { BarcodeScannerDialogComponent } from './interface/reportControls/barcode-scanner/barcode-scanner-dialog.component';
import { BarcodeScannerButtonComponent } from './interface/reportControls/barcode-scanner/barcode-scanner-button.component';
import { ReportSideTabsComponent } from './interface/report-side-tabs/report-side-tabs.component';
import { DataFormContentComponent } from './dataForm/data-form-content.component';

@NgModule({
    declarations: [
        BarcodeScannerButtonComponent,
        BarcodeScannerDialogComponent,
        ReportComponent,
        ReportPrintComponent,
        DataFormContentComponent,
        DataFormDialogComponent,
        DataReportComponent,
        DataReportDisplayComponent,
        FeatureReportComponent,
        FeatureReportDisplayComponent,
        MediaUploadComponent,
        ReportControlsComponent,
        ReportDisplayBaseComponent,
        ReportSelectorComponent,
        ReportSideTabsComponent,
        ReportTabsComponent,
        ReportVideoDialogComponent,
        UploadComponent,
        UploadDialogComponent,
    ],
    exports: [
        ReportComponent,
        DataFormContentComponent,
        DataFormDialogComponent,
        DataReportComponent,
        DataReportDisplayComponent,
        FeatureReportDisplayComponent,
        ReportVideoDialogComponent,
        UploadDialogComponent,
    ],
    imports: [
        UiModule,
        DataPrintModule,
        GsptModule,
        LineIsolationModule,
        MomentModule,
        ReportContentModule,
        RouterModule,
        SharedModule,
        ZoomButtonModule,
    ],
})
export class ReportModule {}
